"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.carlineEmissionFromRawStrategy = void 0;
const misc_1 = require("../../../utils/misc");
const range_1 = require("../../../utils/range");
const constants_1 = require("../../constants");
const mustacheRenderer_1 = require("../../renderer/mustacheRenderer");
const textResources_1 = require("../../textResources");
const carlineEmissionFromRawStrategy = ({ carline, locale, i18nlanguage }, ret) => {
    const { co2EmissionWltpCombinedMax, co2EmissionWltpCombinedMin, co2EmissionWltpCombinedUnit, isHybrid } = carline.eecModel;
    const resources = new textResources_1.I18nText(locale, i18nlanguage);
    if ((0, misc_1.isDefined)(co2EmissionWltpCombinedMax) &&
        (0, misc_1.isDefined)(co2EmissionWltpCombinedMin) &&
        (0, misc_1.isDefined)(co2EmissionWltpCombinedUnit)) {
        const templateKey = isHybrid ? `vue.range.emission.combined.hybrid` : `vue.range.emission.combined`;
        ret.formattedEmission = (0, mustacheRenderer_1.substituteTemplate)(resources.get(templateKey), {
            emissionRange: (0, range_1.formatRangeValue)(locale, {
                min: co2EmissionWltpCombinedMin,
                max: co2EmissionWltpCombinedMax,
                unit: co2EmissionWltpCombinedUnit,
            }, range_1.EMISSION_FRACTION_DIGITS),
            footnote: {
                reference: `{${constants_1.FOOTNOTE_REFERENCE}}`,
            },
        });
    }
    return ret;
};
exports.carlineEmissionFromRawStrategy = carlineEmissionFromRawStrategy;
